import React, { useState, useEffect } from 'react';
import { FormControl } from 'react-bootstrap';

const SearchableInput = ({ column, handleFilterChange, filterValue }) => {
  const { id } = column;
  const value = filterValue || '';

  // Local state to hold the input's current text
  const [inputValue, setInputValue] = useState(value);

  const handleInputChange = (event) => {
    const { value } = event.target;
    setInputValue(value);
  };

  const handleKeyDown = (event) => {

    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission if it's part of a form
      handleFilterChange(id, inputValue, column);
    }
  };
  useEffect(() => {
    setInputValue(value)
  }, [value]);

  useEffect(() => {
    if (filterValue !== undefined) {
      handleFilterChange(id, filterValue, column);
    }
  }, [filterValue]); // only run on mount

  return (
    <FormControl
      type="text"
      id={`searchableinput${id}`}
      placeholder=""
      value={inputValue}
      onChange={handleInputChange}
      onKeyDown={handleKeyDown}
      onBlur={() => {
        if (inputValue === '') {
          handleFilterChange(id, '',column);
        }
      }}
    />
  );
};

export default SearchableInput;